import { SvgIconComponent } from './svg-icon.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

@NgModule({
    imports: [CommonModule],
    declarations: [SvgIconComponent],
    exports: [SvgIconComponent]
})
export class SvgIconModule {}
